import { FC, useContext, useRef } from 'react';
import './TransactionsDateFilterDialog.scss';
import { TransactionsDateFilterContext } from './TransactionsDateFilterContext';
import { TransactionPropertiesGroup } from './TransactionPropertiesGroup';
import { useBooleanSelectOptions } from '../../../hooks/useBooleanSelectOptions';
import { TransactionsContext } from '../../TransactionsContext';
import { useTranslation } from 'react-i18next';
import { TransactionsDateFilterDialogSelect } from './TransactionsDateFilterDialogSelect';
import { TransactionsDateFilterDialogDateRange } from './TransactionsDateFilterDialogDateRange';
import { Button } from 'react-bootstrap';
import { useClickAway } from 'ahooks';

export const TransactionsDateFilterDialog: FC = () => {
  const { customersSelectOptions } = useContext(TransactionsContext);
  const { group, state, setState, setPopupOpened } = useContext(TransactionsDateFilterContext);
  const booleanSelectOptions = useBooleanSelectOptions();
  const { t } = useTranslation();
  const elementRef = useRef<HTMLDivElement | null>(null);

  useClickAway(
    () => {
      setPopupOpened(false);
    },
    elementRef,
    'mousedown',
  );

  return (
    <div className="TransactionsDateFilterDialog" ref={elementRef}>
      {group === TransactionPropertiesGroup.Returned && (
        <TransactionsDateFilterDialogSelect
          label={t('Returned')}
          options={booleanSelectOptions}
          value={state.started}
          onValueChange={(started) => {
            setState((state) => ({
              ...state,
              started,
              startedDateRange: null,
            }));
          }}
        />
      )}

      {(state.started || group === TransactionPropertiesGroup.Left) && (
        <>
          <TransactionsDateFilterDialogDateRange
            label={group === TransactionPropertiesGroup.Returned ? t('Returned at') : t('Left at')}
            value={state.startedDateRange}
            onValueChange={(startedDateRange) =>
              setState((state) => ({
                ...state,
                startedDateRange,
              }))
            }
          />
        </>
      )}

      <TransactionsDateFilterDialogSelect
        label={t('Approved')}
        options={booleanSelectOptions}
        value={state.approved}
        onValueChange={(approved) => {
          setState((state) => ({
            ...state,
            approved,
            approvedBy: null,
            approvedDateRange: null,
          }));
        }}
      />

      {state.approved && (
        <>
          <TransactionsDateFilterDialogDateRange
            label={t('Approved at')}
            value={state.approvedDateRange}
            onValueChange={(approvedDateRange) =>
              setState((state) => ({
                ...state,
                approvedDateRange,
              }))
            }
          />

          {customersSelectOptions && (
            <TransactionsDateFilterDialogSelect
              label={t('Approved by')}
              options={customersSelectOptions}
              value={state.approvedBy}
              onValueChange={(approvedBy) => {
                setState((state) => ({
                  ...state,
                  approvedBy,
                }));
              }}
            />
          )}
        </>
      )}

      <Button
        size="sm"
        variant="outline-primary"
        onClick={() => {
          setPopupOpened(false);
        }}
      >
        {t('Close')}
      </Button>
    </div>
  );
};
